import React, { useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { useOutletContext } from 'react-router-dom';
import SPASectionHeading from '../../shared/SPASectionHeading';
import { useSPAToast } from '../../shared/SPAToast';
import { PanelFooter, panelClass } from '../../shared/formPanel';
import { storeOrderUrlsPayload, toFormValues } from './programForm';
import type { ProgramFormValues } from './programForm';
import StoreOrderUrlsFields from './StoreOrderUrlsFields';
import { EditableProgram, useUpdateProgram } from './useProgram';

const StoreOrderUrlsPanel = () => {
  const program = useOutletContext<EditableProgram>();
  const spaToast = useSPAToast();
  const updateProgram = useUpdateProgram(program.id);
  const values = useMemo(() => toFormValues(program), [program]);
  const form = useForm<ProgramFormValues>({ values });

  const save = (formValues: ProgramFormValues) => {
    updateProgram.mutate(storeOrderUrlsPayload(formValues), {
      onSuccess: () => spaToast.success('Saved store order URLs.'),
    });
  };

  return (
    <form noValidate className={panelClass} onSubmit={form.handleSubmit(save)}>
      <SPASectionHeading className="tw-mb-5" title="Store Order URLs" />
      <StoreOrderUrlsFields form={form} />
      <PanelFooter update={updateProgram} />
    </form>
  );
};

export default StoreOrderUrlsPanel;
